<template>
  <div class="section" id="performer">
    <div class="columns">
      <div class="column is-three-fifths-desktop is-offset-one-fifth-desktop">
        <div class="performerinfo">
          <div class="performerinfo__thumbnail">
            <figure class="image">
              <img :src="$store.state.performer.photoURL" class="is-rounded" />
            </figure>
          </div>
          <h1 class="performerinfo__name">
            {{ $store.state.performer.nickname }}
          </h1>
          <p class="performerinfo__profile">
            {{ $store.state.performer.selfIntroduction }}
          </p>
        </div>
        <b-tabs position="is-centered">
          <b-tab-item label="配信予定">
            <div v-if="!Boolean(upComingLives.length)">配信予定なし</div>
            <div v-if="Boolean(upComingLives.length)" class="nexttime">
              <figure class="image">
                <img :src="upComingLives[0].thumbnailUrl" />
              </figure>
              <p class="nexttime__text">
                {{ upComingLives[0].aboutLive }}
              </p>
            </div>
          </b-tab-item>
          <!-- TODO: リスナーランキングの処理を考える -->
          <!-- {<b-tab-item label="リスナーランキング">
            <ul class="rankinglist">
              <li class="rankinglist__item">
                <router-link to="#">
                  <div class="rankingwrap">
                    <div class="rankingwrap__thumbnail">
                      <img src="http://placehold.jp/144x144.png" />
                    </div>
                    <div class="rankingwrap__text">
                      <p class="rankingwrap__rank">1位</p>
                      <p class="rankingwrap__name">
                        なまえ名前なまえ名前なまえ名前
                      </p>
                    </div>
                  </div>
                </router-link>
              </li>
              <li class="rankinglist__item">
                <router-link to="#">
                  <div class="rankingwrap">
                    <div class="rankingwrap__thumbnail">
                      <img src="http://placehold.jp/144x144.png" />
                    </div>
                    <div class="rankingwrap__text">
                      <p class="rankingwrap__rank">2位</p>
                      <p class="rankingwrap__name">
                        なまえ名前なまえ名前なまえ名前
                      </p>
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>
          </b-tab-item> -->
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Performer',
  computed: {
    upComingLives() {
      return this.$store.getters['live/upComingLives'];
    }
  },
  async created() {
    await this.$store.dispatch(
      'performer/loadPerformerDoc',
      this.$route.params.userId
    );
    console.log(this.$store.state.performer);
    await this.$store.dispatch('live/loadUpComingLivesByUserId', {
      userId: this.$route.params.userId,
      limit: 1
    });
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/performer.scss';
</style>
